/* global axios */
import ApiClient from '../ApiClient';

class CaptainLlmConfigs extends ApiClient {
  constructor() {
    super('captain/llm_configs', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { llm_config: data });
  }

  update(id, data) {
    return axios.put(`${this.url}/${id}`, { llm_config: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  fetchModels(data) {
    return axios.post(`${this.url}/fetch_models`, data);
  }
}

export default new CaptainLlmConfigs();
